module.exports = __webpack_public_path__ + "img/browser-safari-logo.8f59d1cb.png";